/* Smoothly v2 · ajout au panier, alerte retour en stock, apparition au défilement */
(function () {
  if (window.SM2) return;
  var SM2 = window.SM2 = {};
  var KLAVIYO = 'TgdRMG';
  SM2.count = function (n) {
    document.querySelectorAll('[data-sm2-count]').forEach(function (e) { e.textContent = n; });
  };
  SM2.add = function (items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        SM2.count(cart.item_count);
        document.dispatchEvent(new CustomEvent('sm2:added', { detail: { cart: cart } }));
        return cart;
      });
  };
  SM2.bis = function (email, variantId) {
    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' },
      body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } } } })
    }).then(function (r) { if (!r.ok) throw r; return r; });
  };
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-sm2-add]');
    if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]');
    var items = null;
    try { items = JSON.parse(f.getAttribute('data-sm2-items') || 'null'); } catch (err) { items = null; }
    if (!items) {
      var q = f.querySelector('[name=quantity]');
      items = [{ id: +f.querySelector('[name=id]').value, quantity: (q && +q.value) || 1 }];
    }
    if (btn) btn.disabled = true;
    SM2.add(items).then(function () {
      if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-done') || 'Ajouté ✓'; }
    }).catch(function (err) {
      if (btn) { btn.disabled = false; btn.textContent = (err && err.status === 422) ? 'Stock insuffisant' : 'Réessayer'; }
    });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sm2-bis]');
    if (!b || b.hasAttribute('data-done')) return;
    var card = b.closest('.sm2-card');
    var f = card && card.querySelector('[data-sm2-bisform]');
    if (!f) return;
    b.closest('.sm2-card__buy').hidden = true;
    f.hidden = false;
    var i = f.querySelector('input');
    if (i) i.focus();
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-sm2-bisform]');
    if (!f) return;
    e.preventDefault();
    var i = f.querySelector('input');
    var m = (i.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(m)) { i.focus(); return; }
    var btn = f.querySelector('button');
    btn.disabled = true;
    SM2.bis(m, f.getAttribute('data-sm2-bisform')).then(function () {
      var card = f.closest('.sm2-card');
      f.hidden = true;
      var buy = card.querySelector('.sm2-card__buy');
      buy.hidden = false;
      var b = buy.querySelector('[data-sm2-bis]');
      b.textContent = 'Tu seras prévenue';
      b.setAttribute('data-done', '1');
    }).catch(function () { btn.disabled = false; btn.textContent = 'Réessayer'; });
  });
  /* Apparition douce des blocs au défilement */
  function reveal() {
    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sel = '.sm2-statement__p,.sm2 .sm2-head,.sm2-card,.sm2-diagb__txt,.sm2-diagb__card,.sm2-rit__card,.sm2-duo,.sm2-prv__l,.sm2-prv__r,.sm2-cat__item,.sm2-avis__card,.sm2-eng__it,.sm2-guide__card,.sm2-nl__in,.sm2-geste__it,.sm2-form__img,.sm2-form__r,.sm2-pav__l,.sm2-pav__r,.sm2-reass__it,.sm2-bq__promo,.sm2-foot__cols,.sm2-foot__m';
    var els = [].slice.call(document.querySelectorAll(sel));
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) {
      if (el.closest('.sm2-hero,.sm2-cart,.sm2-menu,.sm2-buy,.sm2-gal')) return;
      if (el.getBoundingClientRect().top < vh * 0.92) return;
      var sibs = el.parentNode ? [].indexOf.call(el.parentNode.children, el) : 0;
      el.style.transitionDelay = Math.min(sibs, 4) * 80 + 'ms';
      el.classList.add('sm2-rv');
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal); else reveal();
})();
